module.exports = __webpack_public_path__ + "img/logo.d1adaa27.svg";